/** @type {import("vuex").Module} */
export const tool = {
    namespaced: true,

    state: {
        side: null,
        type: null,
    },

    getters: {
        isOn(state) {
            return !!state.side && !!state.type;
        },
    },

    mutations: {
        init(state, { side = null, type = null } = {}) {
            if (state.side == side && state.type == type) {
                side = null;
                type = null;
            }
            state.side = side;
            state.type = type;
        },
    },

    actions: {
        reset(store) {
            store.commit("init");
        },
    },
};

export default tool;
